import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCode, faFont, faGlobe, faImage, faMusic, faVideo } from "@fortawesome/free-solid-svg-icons";

export const LIGHTBOX_ELEMENTS = [
    { value: "video", label: "Video", typeId: 5, icon: faVideo },
    { value: "image", label: "Image", typeId: 4, icon: faImage },
    { value: "text", label: "Text", typeId: 7, icon: faFont },
    { value: "audio", label: "Audio", typeId: 8, icon: faMusic },
    { value: "embed", label: "Embed URL", typeId: 6, icon: faGlobe },
    { value: "html", label: "HTML", typeId: 12, icon: faCode },
];

export const typeIdFor = (value) => LIGHTBOX_ELEMENTS.find((e) => e.value === value)?.typeId;

const LightBoxElement = ({ lightBoxPayload, chosenType, handleChange }) => (
    <div className="lb-content-types">
        <div className="lb-type-tiles" role="radiogroup" aria-label="Content type">
            {LIGHTBOX_ELEMENTS.map(({ value, label, typeId, icon }) => (
                <label key={value} className={`lb-type-tile${chosenType === typeId ? " active" : ""}`}>
                    <input
                        type="radio"
                        name="element"
                        value={value}
                        checked={chosenType === typeId}
                        onChange={handleChange}
                    />
                    <FontAwesomeIcon icon={icon} />
                    <span>{label}</span>
                </label>
            ))}
        </div>
    </div>
);

export default LightBoxElement;
